import type { Language, Product, ShopSettings } from "../../shared/types";
import { copy, money } from "./i18n";

export function buildWhatsAppOrderUrl(
  language: Language,
  settings: ShopSettings,
  products: Product[],
  basket: Record<string, number>,
) {
  const t = copy[language];
  const selected = products.filter((product) => basket[product.id] > 0);
  if (!selected.length) return null;
  const title = (product: Product) => language === "ku" ? product.title_ku : product.title_ar;
  const color = (product: Product) => language === "ku" ? product.color_ku : product.color_ar;
  const total = selected.reduce((sum, product) => sum + product.price_iqd * basket[product.id], 0);
  const lines = selected.flatMap((product, index) => {
    const quantity = basket[product.id];
    const rows = [`${index + 1}- ${title(product)}`, `${t.quantity}: ${quantity}`];
    if (color(product)) rows.push(`${t.color}: ${color(product)}`);
    rows.push(`${t.price}: ${money(product.price_iqd, language)}`, `${t.subtotal}: ${money(product.price_iqd * quantity, language)}`);
    return [...rows, ""];
  });
  const message = [t.hello, "", ...lines, `${t.total}: ${money(total, language)}`].join("\n");
  const digits = settings.phone.replace(/\D/g, "").replace(/^0/, "964");
  return `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
}
